import type { ReactNode } from "react";
import {
  DISPLAY_TIMEZONE,
  kabulDatetimeLocalToUtcIso,
  utcIsoToKabulDatetimeLocal,
} from "@vital/shared";

type Props = {
  startsAtLocal: string;
  endsAtLocal: string;
  onStartsAtChange: (value: string) => void;
  onEndsAtChange: (value: string) => void;
  required?: boolean;
  legend?: string;
  hint?: ReactNode | null;
  compact?: boolean;
};

export function ScheduleFields({
  startsAtLocal,
  endsAtLocal,
  onStartsAtChange,
  onEndsAtChange,
  required = false,
  legend,
  hint,
  compact = false,
}: Props) {
  const hintNode =
    hint === null
      ? null
      : (hint ?? (
          <>
            زمان‌ها بر اساس{" "}
            <bdi dir="ltr" className="ltr-isolate">
              {DISPLAY_TIMEZONE}
            </bdi>{" "}
            وارد می‌شوند و به UTC ذخیره می‌گردند.
          </>
        ));

  return (
    <fieldset className={`schedule-fieldset${compact ? " schedule-fieldset--compact" : ""}`}>
      <legend>{legend ?? (required ? "بازهٔ زمانی (الزامی)" : "بازهٔ زمانی (اختیاری)")}</legend>
      {!compact && hintNode ? <p className="field-hint">{hintNode}</p> : null}
      <div className={compact ? "composer-fields-row" : undefined}>
        <label>
          <span>شروع</span>
          <input
            type="datetime-local"
            dir="ltr"
            className="ltr-isolate"
            value={startsAtLocal}
            required={required}
            onChange={(e) => onStartsAtChange(e.target.value)}
          />
        </label>
        <label>
          <span>پایان</span>
          <input
            type="datetime-local"
            dir="ltr"
            className="ltr-isolate"
            value={endsAtLocal}
            required={required}
            onChange={(e) => onEndsAtChange(e.target.value)}
          />
        </label>
      </div>
      {compact && hintNode ? <p className="field-hint field-hint--tight">{hintNode}</p> : null}
    </fieldset>
  );
}

export function schedulePayloadFromLocal(startsAtLocal: string, endsAtLocal: string) {
  return {
    startsAt: kabulDatetimeLocalToUtcIso(startsAtLocal),
    endsAt: kabulDatetimeLocalToUtcIso(endsAtLocal),
  };
}

export function localScheduleFromIso(startsAt: string | null, endsAt: string | null) {
  return {
    startsAtLocal: utcIsoToKabulDatetimeLocal(startsAt),
    endsAtLocal: utcIsoToKabulDatetimeLocal(endsAt),
  };
}

export { formatKabulDisplay } from "@vital/shared";
